<template>
  <v-autocomplete
    v-bind:label="label"
    v-model="fieldValue"
    :items="listElements"
    :loading="isLoading"
    :search-input.sync="filterListElements"
    @change="change"
    clearable
  ></v-autocomplete>
</template>

<script>
import InternalTableService from "@/services/InternalTableService";

export default {
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
    },
    internalTableId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      fieldValue: null,
      search: null,
      listElements: [],
      filteredListElements: [],
      isLoading: false,
    };
  },
  created() {
    this.fieldValue = this.value;
  },
  mounted() {
    this.getListElements();
  },
  methods: {
    getListElements() {
      this.isLoading = true;

      InternalTableService.getLinkedTableData(this.internalTableId)
        .then((result) => {
          this.listElements = result;
          this.filterListElements();
        })
        .finally((x) => (this.isLoading = false));
    },
    filterListElements(search) {
      this.filteredListElements = (search
        ? this.listElements.filter((e) =>
            (e.text || "").toLowerCase().includes(search.toLowerCase())
          )
        : this.listElements
      ).slice(0, 200);
    },
    change() {
      this.$emit("update:value", this.fieldValue);
    },
  },
};
</script>

<style>
</style>